import { createContext } from 'react';

type GeneralContextProps = {
  isMozzila: boolean;
  isSafari: boolean;
  isChrome: boolean;
};

export default createContext<Partial<GeneralContextProps>>({
  isMozzila: false,
  isChrome: false,
  isSafari: false,
});
